<template>
  <!-- Modal -->
  <div class="modal fade" id="changeHddModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Update Disk Space of SolusVM VPS</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Disk Space:</label>
            <input type="number" min="1" class="form-control" v-model="newHdd"/>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="!hddLoading" type="button" class="btn btn-primary" @click="updateHdd()">Update</button>
          <div v-else class="loader small_loader"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {db} from "@/firebase/init";

export default {
  name: "changeHddModal",
  data () {
    return {
      account: {},
      newHdd: 0,
      hddLoading: false
    }
  },
  computed: {
    UID(){
      return this.$store.getters.getUID;
    }
  },
  methods: {
    load (account) {
      this.account = account
      this.newHdd = parseFloat((this.account.hdd.total / Math.pow(1024, 3)).toFixed(1));
      $("#changeHddModal").modal('show');
      $(".modal-backdrop").appendTo(".add-addon-domain-modal");
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async updateHdd() {
      const account = this.account;
      const used = account.hdd.used;
      const vmId = account.solusVM_VPS_ID;
      try{
        const usedInGB = parseFloat((used / Math.pow(1024, 3)).toFixed(1));
        const usedBuffer = parseFloat((usedInGB * 0.10).toFixed(1)); // 10% buffer
        const finalComparisonWithUsed = usedInGB + usedBuffer;
        console.log(this.newHdd, finalComparisonWithUsed);
        if(parseFloat(this.newHdd) < parseFloat(finalComparisonWithUsed)) {
          swal('Error!', 'Disk space must be greater than used space!', 'error');
          return;
        }
        this.hddLoading = true;
        const changeHDDResp = await this.$http.post('/solus-vm/change_hdd', {
          vmId: vmId,
          newHdd: parseFloat(this.newHdd),
          grant_type: 'token'
        });
        await this.syncVPSDetails(account);
        swal('HDD Changed!', changeHDDResp.data.message, 'success');
      }catch (err) {
        console.error(err);
        swal('Error!', err.response.data.message, 'error');
        this.hddLoading = false;
      }
    },
    async syncVPSDetails(account) {
      console.log(account);
      let vmId = '';
      try{
        this.hddLoading = true;
        const accountResp = await this.$http.post('/solus-vm/fetch_client_accounts', {
          clientId: account.hbServiceID,
          grant_type: 'token'
        });
        if(accountResp.data.hbAccounts){
          const hbAccountDetails = accountResp.data.hbAccounts;
          const accountRef = await db.collection('hostingAccounts').doc(this.UID).get();
          const {accounts} = accountRef.data();
          accounts[account.planIndex].primary.solusVM_VPS_ID = (!hbAccountDetails.extra_details.option6) ? '' : hbAccountDetails.extra_details.option6;
          accounts[account.planIndex].primary.hbHostname = hbAccountDetails.domain;
          accounts[account.planIndex].primary.hbServiceID = account.hbServiceID;
          await db.collection('hostingAccounts').doc(this.UID).update({
            accounts: accounts
          });
          vmId = hbAccountDetails.extra_details.option6;
          try {
            const accMapRef = await db.collection('account-hb')
                .where('uid', '==', this.UID)
                .where('domain', '==', accounts[account.planIndex].primary.domain)
                .get();
            if (accMapRef.size > 0) {
              await db.collection('account-hb')
                  .doc(accMapRef.docs[0].id)
                  .update({
                    hbServiceID: account.hbServiceID,
                    solusVM_VPS_ID: (!hbAccountDetails.extra_details.option6) ? '' : hbAccountDetails.extra_details.option6,
                    hbHostname: hbAccountDetails.domain,
                  });
            }
          } catch (e) {
            console.log(e.toString())
          }
        }else{
          swal('Error!', accountResp.data.message, 'error');
        }
        if(vmId) {
          const nodeInfoResp = await this.$http.post('/solus-vm/fetch_node_info', {
            vmId: vmId,
            grant_type: 'token'
          });
          if(nodeInfoResp.data.status === 'success') {
            const hddInfo = nodeInfoResp.data.hdd.split(',');
            const accountRef = await db.collection('hostingAccounts').doc(this.UID).get();
            const {accounts} = accountRef.data();
            const beforePayload = JSON.parse(JSON.stringify(accounts))
            accounts[account.planIndex].primary.hdd = {
              total: hddInfo[0],
              used: hddInfo[1],
              free:hddInfo[2],
              usedPercent: hddInfo[3]
            };
            await this.addHostingAccountEventLog({hostingAccountId : this.UID ,  afterPayload: accounts , beforePayload : beforePayload, action: 'Sync VPS Details'})
            await db.collection('hostingAccounts').doc(this.UID).update({
              accounts: accounts
            })
          }else {
            swal('Error!', nodeInfoResp.data.message, 'error');
          }
        }else{
          const accountRef = await db.collection('hostingAccounts').doc(this.UID).get();
          const {accounts} = accountRef.data();
          const beforePayload = JSON.parse(JSON.stringify(accounts))
          accounts[account.planIndex].primary.hdd = '';
          await this.addHostingAccountEventLog({hostingAccountId : this.UID ,  afterPayload: accounts , beforePayload: beforePayload, action: 'Sync VPS Details'})
          await db.collection('hostingAccounts').doc(this.UID).update({
            accounts: accounts
          })
        }
        $("#changeHddModal").modal('hide');
      }catch (err) {
        console.error(err);
        swal('Error!', err.response.data.message, 'error');
      }
      this.hddLoading = false;
    },
  }
}
</script>

<style scoped>

</style>
